import React, { useState } from 'react';
import { X, Clock } from 'lucide-react';
import { meGhostBtnClass, meInputClass, meLabelClass, meModalOverlayClass, meModalPanelClass, mePrimaryBtnClass, meSecondaryBtnClass } from './marketingEmailUi';

interface ScheduleSendModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (scheduledAt: string) => void;
  title?: string;
}

const ScheduleSendModal: React.FC<ScheduleSendModalProps> = ({ open, onClose, onConfirm, title }) => {
  const defaultDate = () => {
    const d = new Date();
    d.setHours(d.getHours() + 1, 0, 0, 0);
    return d.toISOString().slice(0, 16);
  };

  const [dateTime, setDateTime] = useState(defaultDate());

  React.useEffect(() => {
    if (open) setDateTime(defaultDate());
  }, [open]);

  if (!open) return null;

  return (
    <div className={meModalOverlayClass}>
      <div className={`${meModalPanelClass} max-w-md`}>
        <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4 dark:border-gray-800">
          <div className="flex items-center gap-2">
            <Clock className="h-5 w-5 text-primary" />
            <h3 className="font-semibold text-gray-900 dark:text-white">{title || 'Schedule send'}</h3>
          </div>
          <button type="button" onClick={onClose} className={meGhostBtnClass}>
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-4 px-5 py-4">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Choose when this campaign should be sent. Times use your local timezone.
            Scheduled emails are sent by the Vedika reminder engine (runs every minute).
          </p>
          <div>
            <label className={meLabelClass}>Date & time</label>
            <input
              type="datetime-local"
              value={dateTime}
              onChange={(e) => setDateTime(e.target.value)}
              min={new Date().toISOString().slice(0, 16)}
              className={meInputClass}
            />
            {dateTime && new Date(dateTime).getTime() <= Date.now() && (
              <p className="mt-1 text-xs text-red-500">Pick a future date and time</p>
            )}
          </div>
        </div>

        <div className="flex justify-end gap-2 border-t border-gray-200 px-5 py-4 dark:border-gray-800">
          <button type="button" onClick={onClose} className={meSecondaryBtnClass}>Cancel</button>
          <button
            type="button"
            onClick={() => {
              const chosen = new Date(dateTime);
              if (Number.isNaN(chosen.getTime()) || chosen.getTime() <= Date.now()) {
                return;
              }
              onConfirm(chosen.toISOString());
            }}
            disabled={!dateTime || new Date(dateTime).getTime() <= Date.now()}
            className={mePrimaryBtnClass}
          >
            Schedule
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScheduleSendModal;
